import React from 'react'

import Experiment from '@mc/experiments-react'
import { Trans } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { useStaticData } from '@mc/static-data-react'

import { StaticData } from 'types/libs/staticData'

import { MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME } from '../hooks/useTrackPen5222Experiment'
import { MONEY_BACK_PRICING_MICROCOPY_I18N_NAMESPACE } from '../i18n'
import type { Pen5222PricingTextWrapperProps } from './Pen5222PricingTextWrapper'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'

export const Pen5222PromoPricingTextWrapper = ({
  control,
  translationKey,
  children,
  hidePricingMicrocopyExperiment,
}: Pen5222PricingTextWrapperProps) => {
  const validExperimentCriteria = useExperimentCriteria()

  if (hidePricingMicrocopyExperiment || !validExperimentCriteria) return control

  return (
    <Experiment
      name={MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME}
      control={() => control}
      variant_1={() => (
        <Variant1Text translationKey={translationKey}>{children}</Variant1Text>
      )}
      variant_2={() => (
        <Variant2Text translationKey={translationKey}>{children}</Variant2Text>
      )}
      track={false}
    />
  )
}

const Variant1Text = ({
  translationKey,
  children,
}: {
  translationKey?: Pen5222PricingTextWrapperProps['translationKey']
  children?: Pen5222PricingTextWrapperProps['children']
}) => {
  const { annualPass } = useStaticData<StaticData>()
  const price = annualPass?.monetizedYearPricePerMonthDiscounted
  const strikeThroughPrice = annualPass?.monetizedYearPricePerMonth

  const key =
    translationKey === 'shortPriceStyled' ? 'shortPriceStyled.promo' : 'promo'

  return (
    <Trans
      i18nKey={`pricing.variant_1.${key}`}
      values={{
        strikeThroughPrice,
        price,
      }}
      ns={MONEY_BACK_PRICING_MICROCOPY_I18N_NAMESPACE}
    >
      {children}
    </Trans>
  )
}

const Variant2Text = ({
  translationKey,
  children,
}: {
  translationKey?: Pen5222PricingTextWrapperProps['translationKey']
  children?: Pen5222PricingTextWrapperProps['children']
}) => {
  const { annualPass } = useStaticData<StaticData>()
  const price = annualPass?.monetizedYearPricePerMonthDiscounted
  const strikeThroughPrice = annualPass?.monetizedYearPricePerMonth

  const key =
    translationKey === 'shortPriceStyled' ? 'shortPriceStyled.promo' : 'promo'

  return (
    <Trans
      i18nKey={`pricing.variant_2.${key}`}
      values={{
        strikeThroughPrice,
        price,
        instructors: getNumberOfInstructors(),
      }}
      ns={MONEY_BACK_PRICING_MICROCOPY_I18N_NAMESPACE}
    >
      {children}
    </Trans>
  )
}
